import { ApiQueryParams, apiRequest } from '../Api';

export type ImportWebsiteElementRequest = ApiQueryParams;

export interface ImportWebsiteElementResponse {
  success: boolean;
  message: string;
  // Newer API shape nests bulk import info under data
  data?: {
    message?: string;
    bulk_import_id?: string;
    status?: 'Received' | 'Processing' | 'Completed' | 'Failed';
    note?: string;
  };
  execution_time?: number;
  cached?: boolean;
  timestamp?: string;
  // Legacy bulk import specific fields (top-level) - kept for backward compatibility
  bulk_import_id?: string;
  status?: 'Received' | 'Processing' | 'Completed' | 'Failed';
  note?: string;
}

export const importWebsiteElements = (
  params: ImportWebsiteElementRequest,
  data: unknown[]
) =>
  apiRequest<unknown, ImportWebsiteElementResponse>({
    url: '/entities/bulk-import',
    scope: 'element',
    method: 'POST',
    params: params as ApiQueryParams & Record<string, string | number | boolean>,
    data: { payload: data },
  });

